import moment from "jalali-moment";
import { Season } from "../../../../../../features/growing-season/domain/growing-season.interface";
import { areaCalculation } from "../../../../../../features/map/utils/area-calculation";
import { reportColor } from "../../../utils/report-color";
import { toolbarBaseControls } from "../../../../../../features/map/utils/configs";
import { FieldMarkerIcon } from "../../../../../../components/map/utils/customs";
import { ServiceType } from "@agroyaar/sdk";
import AgroMapSeason from "../../../../../../features/map/presentation/components/AgroMapSeason";

interface SeasonInformationProps {
  season: Season;
  serviceType: ServiceType;
}

const SeasonInformation = ({ season, serviceType }: SeasonInformationProps) => {
  const seasonArea = areaCalculation(season.area);

  const colorCode = reportColor(serviceType);

  return (
    <div className="flex flex-col justify-center items-start w-1/2 gap-2">
      <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
        اطلاعات فصل رشد
      </span>

      <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
        <div
          className="relative overflow-hidden  rounded-full w-[80px] h-[80px]"
          style={{ border: `2px solid ${colorCode}` }}
        >
          <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
          <AgroMapSeason
            mapId={season.id}
            type="onlyShow"
            // @ts-ignore
            toolbarOptions={toolbarBaseControls}
            markerIcon={FieldMarkerIcon}
            currentSeasonPolygon={season.polygon}
          />
        </div>
        <div className="text-[18px] font-bold text-[var(--agrotext)] flex flex-col justify-center items-start gap-[6px]">
          <div className="flex flex-row items-start gap-2">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              نام محصول:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {season.product.persianName}
            </span>
          </div>

          <div className="flex flex-row items-start gap-2">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              مساحت زمین:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {seasonArea}
            </span>
          </div>

          <div className="flex flex-row items-start gap-2">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              فصل رشد:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {moment(`${season.growingSeason}-04-01`, "YYYY-MM-DD")
                .locale("fa")
                .format("YYYY")}{" "}
              {season.persianName ? ` - ${season.persianName}` : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeasonInformation;
